<template>
  <Modal
    title="Добавить аксессуары"
    :is-show="isShow"
    @close="close"
  >
    <form
      class="form"
      @submit.prevent="submit"
    >
      <div class="accessoriesList">
        <div class="accessoriesList-item">
          <div class="accessoriesList-value">
            <Checkbox
              v-model="form.back_strips"
              :disabled="form.back_wall || form.back_screen"
            >
              Ограничительные планки задние
            </Checkbox>
          </div>
          <div class="accessoriesList-image">
            <img src="accessorie.png" alt="">
          </div>
          <div class="accessoriesList-count">
            Кол-во <input type="text" v-model="form.back_strips_count"> шт
            <a href="#" @click.prevent="form.back_strips_count = count - 1">Добавить на все полки</a>
          </div>
        </div><!-- .accessoriesList-item -->
        <div class="accessoriesList-item">
          <div class="accessoriesList-value">
            <Checkbox
              v-model="form.side_strips_left"
              :disabled="form.side_screen"
            >
              Ограничительные планки слева
            </Checkbox>
          </div>
          <div class="accessoriesList-image">
            <img src="accessorie.png" alt="">
          </div>
          <div class="accessoriesList-count">
            Кол-во <input type="text" v-model="form.side_strips_left_count"> шт
            <a href="#" @click.prevent="form.side_strips_left_count = (count - 1)">Добавить на все полки</a>
          </div>
        </div><!-- .accessoriesList-item -->
        <div class="accessoriesList-item">
          <div class="accessoriesList-value">
            <Checkbox
              v-model="form.side_strips_right"
              :disabled="form.side_screen"
            >
              Ограничительные планки справа
            </Checkbox>
          </div>
          <div class="accessoriesList-image">
            <img src="accessorie.png" alt="">
          </div>
          <div class="accessoriesList-count">
            Кол-во <input type="text" v-model="form.side_strips_right_count"> шт
            <a href="#" @click.prevent="form.side_strips_right_count = (count - 1)">Добавить на все полки</a>
          </div>
        </div><!-- .accessoriesList-item -->
        <div class="accessoriesList-item">
          <div class="accessoriesList-value">
            <Checkbox
              v-model="form.separators"
            >
              Разделители
            </Checkbox>
          </div>
          <div class="accessoriesList-image">
            <img src="accessorie.png" alt="">
          </div>
          <div class="accessoriesList-count">
            Кол-во <input type="text" v-model="form.separators_count"> шт
          </div>
        </div><!-- .accessoriesList-item -->
        <div class="accessoriesList-item" v-if="separate">
          <div class="accessoriesList-value">
            <Checkbox
              v-model="form.back_wall"
              :disabled="form.back_strips || form.back_screen"
            >
              Задняя стенка
            </Checkbox>
          </div>
          <div class="accessoriesList-image">
            <img src="accessorie.png" alt="">
          </div>
          <div class="accessoriesList-count" />
        </div><!-- .accessoriesList-item -->
        <div class="accessoriesList-item" v-if="separate">
          <div class="accessoriesList-value">
            <Checkbox
              v-model="form.back_screen"
              :disabled="!canBackScreen || form.back_strips || form.back_wall"
              hint="Возможно только для ширины 1000"
            >
              Задний экран
            </Checkbox>
          </div>
          <div class="accessoriesList-image">
            <img src="accessorie.png" alt="">
          </div>
          <div class="accessoriesList-count">
            Кол-во <input type="text" v-model="form.back_screen_count"> шт
          </div>
        </div><!-- .accessoriesList-item -->
        <div class="accessoriesList-item" v-if="separate">
          <div class="accessoriesList-value">
            <Checkbox
              v-model="form.side_wall_right"
              :disabled="form.side_screen"
              hint="Если у соседнего стеллажа справа выбрана стенка справа, она будет общей для обоих стеллажей"
            >
              Боковая стенка справа
            </Checkbox>
          </div>
          <div class="accessoriesList-image">
            <img src="accessorie.png" alt="">
          </div>
          <div class="accessoriesList-count" />
        </div><!-- .accessoriesList-item -->
        <div class="accessoriesList-item" v-if="separate">
          <div class="accessoriesList-value">
            <Checkbox
              v-model="form.side_wall_left"
              :disabled="form.side_screen"
              hint="Если у соседнего стеллажа слева выбрана стенка слева, она будет общей для обоих стеллажей"
            >
              Боковая стенка слева
            </Checkbox>
          </div>
          <div class="accessoriesList-image">
            <img src="accessorie.png" alt="">
          </div>
          <div class="accessoriesList-count" />
        </div><!-- .accessoriesList-item -->
        <div class="accessoriesList-item" v-if="separate">
          <div class="accessoriesList-value">
            <Checkbox
              v-model="form.side_screen"
              :disabled="!canSideScreen || form.side_strips_left || form.side_strips_right || form.side_wall_right || form.side_wall_left"
              hint="Возможно только для глубины 500"
            >
              Комплект боковых экранов Garage MS (2 шт.)
            </Checkbox>
          </div>
          <div class="accessoriesList-image">
            <img src="accessorie.png" alt="">
          </div>
          <div class="accessoriesList-count">
            Кол-во <input type="text" v-model="form.side_screen_count"> шт
          </div>
        </div><!-- .accessoriesList-item -->
      </div><!-- .accessoriesList -->

      <div class="field">
        <button
          type="submit"
          class="btn"
        >
          <span>Применить</span>
        </button>
        <button
          type="button"
          class="btn"
          @click="close"
        >
          <span>Отмена</span>
        </button>
      </div>

      <div class="hint">
        Изображение аксессуаров на схеме схематичное. Количество выбранных аксессуаров может не совпадать с количеством изображенных.
      </div>
    </form>
  </Modal>
</template>

<script>
  import Modal from './Modal.vue';
  import Checkbox from './Checkbox.vue';

  export default {
    components: {
      Modal,
      Checkbox,
    },
    props: {
      isShow: Boolean,
      separate: Boolean,
      canBackScreen: {
        type: Boolean,
        default: false,
      },
      canSideScreen: {
        type: Boolean,
        default: false,
      },
      count: {
        type: Number,
        default: 3,
      },
      value: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        form: {
          back_strips: false,
          back_strips_count: 0,
          side_strips_left: false,
          side_strips_left_count: 0,
          side_strips_right: false,
          side_strips_right_count: 0,
          separators: false,
          separators_count: 0,
          back_wall: false,
          back_screen: false,
          back_screen_count: 0,
          side_wall_right: false,
          side_wall_left: false,
          side_screen: false,
          side_screen_count: 0,
        },
      };
    },
    mounted() {
      this.form = Object.assign({}, this.form, this.value);
    },
    methods: {
      close() {
        this.$emit('close');
      },
      submit() {
        this.$emit('input', this.form);
        this.$emit('close');
      },
    },
  };
</script>

<style scoped>
  .form button {
    width: auto;
  }
  .accessoriesList {
    margin-bottom: 40px;
    font-size: 14px;
  }
  .accessoriesList a {
    text-decoration: none;
    color: #0B53B3;
  }
  .accessoriesList-item {
    display: flex;
    padding: 16px 0;
    border-top: 1px solid #DDDDDD;
    border-bottom: 1px solid #DDDDDD;
  }
  .accessoriesList-item + .accessoriesList-item {
    border-top: none;
  }
  .accessoriesList-value {
    flex-grow: 1;
    margin-right: 23px;
  }
  .accessoriesList-image {
    width: 48px;
    margin-right: 23px;
  }
  .accessoriesList-count {
    width: 190px;
  }
  .accessoriesList-count input {
    margin: 0 9px;
    width: 47px;
    height: 32px;
    text-align: center;
    background: white;
    border: 1px solid #CECECE;
    appearance: textfield;
  }
  .hint {
    margin-top: 22px;
    width: 644px;
    font-size: 14px;
    color: #A7A7A7;
  }
</style>
